// src/pages/PrintView.jsx
import React, { useEffect, useMemo, useState } from "react";
import { getCurrentWebviewWindow } from "@tauri-apps/api/webviewWindow";

const QUEUE_KEY = "__print_queue__";
const RETURN_KEY = "__print_return__";

function isTauri() {
  return typeof window !== "undefined" && !!window.__TAURI__;
}

function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]") || [];
  } catch {
    return [];
  }
}

function setQueue(q) {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(q || []));
}

function getReturnUrl() {
  return localStorage.getItem(RETURN_KEY) || "";
}

export default function PrintView() {
  const [job, setJob] = useState(null);
  const [stage, setStage] = useState("init"); // init | printing | done

  const containerStyle = useMemo(
    () => ({
      width: "80mm",
      margin: "0 auto",
      background: "#fff",
      padding: "6px",
    }),
    []
  );

  useEffect(() => {
    const q = getQueue();
    if (!q.length) {
      setStage("done");
      return;
    }
    setJob(q[0]);
  }, []);

  useEffect(() => {
    if (!job || stage !== "init") return;

    const run = async () => {
      setStage("printing");

      // انتظر رسم الصفحة
      await new Promise((r) => setTimeout(r, 250));

      try {
        if (isTauri()) {
          const w = getCurrentWebviewWindow();
          await w.print(); // ✅ يحتاج core:webview:allow-print في mobile capability
        } else {
          window.print();
        }
      } catch (e) {
        console.error("print failed:", e);
      }

      // بعد محاولة الطباعة: احذف أول عنصر وكمّل التالي
      const q = getQueue();
      q.shift();
      setQueue(q);

      if (q.length) {
        setJob(q[0]);
        setStage("init");
      } else {
        setStage("done");
      }
    };

    run();
  }, [job, stage]);

  useEffect(() => {
    if (stage !== "done") return;
    const back = () => {
      const ret = getReturnUrl();
      if (ret) window.location.href = ret;
      else window.history.back();
    };
    const t = setTimeout(back, 350);
    return () => clearTimeout(t);
  }, [stage]);

  if (!job) {
    return (
      <div dir="rtl" style={{ padding: 16, fontFamily: "Tajawal, system-ui" }}>
        لا توجد مهمة طباعة.
      </div>
    );
  }

  return (
    <div dir="rtl" style={{ padding: 8, fontFamily: "Tajawal, system-ui" }}>
      <div style={{ textAlign: "center", marginBottom: 6, color: "#444" }}>
        {job?.title || "طباعة..."}
      </div>

      <div
        style={containerStyle}
        dangerouslySetInnerHTML={{ __html: job?.html || "" }}
      />
    </div>
  );
}
